import $ from './el.JsModules.js';

elabs.BrandPillarsPdp = class {
  'use strict';

  constructor(element) {
    this.view = $(element);
    this.swiperSlider = null;
    const sectionId = this.view.data('section-id');
    this.breakpoint = window.matchMedia('(min-width: 1000px)');
    this.breakpoint.addEventListener('change', () => this.initSlider({ sectionId }));

    this.initSlider({ sectionId });
  }

  initSlider({ sectionId }) {
    if (this.breakpoint.matches) {
      if (this.swiperSlider) {
        this.swiperSlider.destroy(true, true);
        this.swiperSlider = null;
      }
      return;
    }
    if (this.swiperSlider) return;
    const _this = this;
    this.swiperSlider = new Swiper(`[data-section-id="${sectionId}"] .swiper`, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      breakpoints: {
        680: {
          spaceBetween: 32,
        },
      },
      on: {
        slideChange: function (e) {
          const stickyLabel = _this.view[0].querySelector('.brand-pillars-pdp__sticky-label');
          if (!stickyLabel) return;

          if (this.activeIndex > 0) {
            stickyLabel.classList.add('brand-pillars-pdp__sticky-label--hidden');
          } else {
            stickyLabel.classList.remove('brand-pillars-pdp__sticky-label--hidden');
          }
        },
      },
    });
  }
};

elabs.onJavascriptReady(function () {
  $('.brand-pillars-pdp').each(function (index, element) {
    new elabs.BrandPillarsPdp(element);
  });
});
